import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  confirmButtonText: {
    id: 'jutro-components.modal.AlertModal.confirmButtonText',
    defaultMessage: 'Close'
  }
});